import { Component, Input,  OnInit } from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators, SelectMultipleControlValueAccessor } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { FournisseurListDto } from 'src/app/core/models/entreprise/fournisseur-list-dto';
import { FournisseurService } from 'src/app/parametrage/core/service/fournisseur.service';
import { FournisseurItemDto } from 'src/app/core/models/entreprise/fournisseur-item-dto';

@Component({
  selector: 'app-add-fournisseur',
  templateUrl: './add-fournisseur.component.html',
  styleUrls: ['./add-fournisseur.component.css']
})
export class AddFournisseurComponent implements OnInit {

  @Input() requestId;

  pressButton:Boolean = false;

  form: FormGroup;

  fournisseurs:FournisseurListDto = new FournisseurListDto();

  public fournisseurList: FormArray;
  
  indexFournisseur: Number = 0;

  get fournisseurFormGroup() {
    return this.form.get('fournisseurs') as FormArray;
  }

  
  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _fournisseurService: FournisseurService
  ) {
    this.createForm();
  }

  createForm() 
  {

    this.form = this.fb.group({
      fournisseurs:this.fb.array([this.createFournisseur()])
    });

    this.fournisseurList = this.form.get('fournisseurs') as FormArray;
  }

  

  createFournisseur(): FormGroup {
    return this.fb.group({
      nomFournisseur: [null, Validators.compose([Validators.required])]
    });
  }

  addFournisseur() {
    this.fournisseurList.push(this.createFournisseur());
    var index = Number(this.indexFournisseur);
    const newIndex = index + 1;
    this.indexFournisseur = newIndex;
  }

  removeFournisseur(index) {
    this.fournisseurList.removeAt(index);
  }

  getFournisseursFormGroup(index): FormGroup {
    const formGroup = this.fournisseurList.controls[index] as FormGroup;
    return formGroup;
  }


  ngOnInit() {
  }

  

  create(): void {
    
    this.pressButton = true;
    let fournisseurs = [];
    fournisseurs = this.creerListFournisseurs();
    this.fournisseurs.fournisseurDtoList = fournisseurs;
    this.fournisseurs.requestId = this.requestId;
    this.spinner.show();

      this._fournisseurService.addListFournisseur(this.fournisseurs)
        .pipe(first())
                .subscribe(
                    data => {
                      this.spinner.hide();
                      this.activeModal.close();
                    },
                    error => {
                      console.log(error);
                      this.spinner.hide();
                });

  }

  creerListFournisseurs()
  {
    const fournisseurItems:FournisseurItemDto[] = [];
    this.form.value.fournisseurs.forEach(function (value) {
      const forunisseur = new FournisseurItemDto();
      forunisseur.nomFournisseur = value.nomFournisseur;
      fournisseurItems.push(forunisseur);
    });

    return fournisseurItems;
  }










}
